export const API_URL = "https://www.kfone.lt/api";
// export const MAX_RETRIES = 5;
export const GAME_SERVER_IP = "159.195.44.113";
export const DISCORD_LINK = "https://discord.gg/G3KGVdw3q8";

// export const ERROR_MESSAGE = 'Something went wrong, please try again!';
